import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import {
  HomeOutlined,
  EditOutlined,
  FormOutlined,
  ZoomInOutlined,
  ProfileOutlined,
  ExceptionOutlined,
  ReadOutlined,
  PhoneOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

const KorisnikView = (props) => {
  return (
    <Menu theme="dark" selectedKeys={[props.selectedKey]} mode="inline">
      <Menu.Item key="1" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/">
          <HomeOutlined />
          <span> POČETNA STRANICA</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="2" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/pregled-registara">
          <ProfileOutlined />
          <span> PREGLED REGISTARA</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="3" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/unos-zahtjeva">
          <EditOutlined />
          <span> {" UNOS ZAHTJEVA"}</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="4" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/pregled-zahtjeva">
          <ZoomInOutlined />
          <span> {" PREGLED ZAHTJEVA"}</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="6" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/nadzorne-mjere">
          <ExceptionOutlined />
          <span>{" NADZORNE MJERE"}</span>
        </Link>
      </Menu.Item>

      {/*PRIKAZIVAT CEMO I PS-ima STRUCNA USAVRŠAVANJA ako to odobre, nitko se više ne sjeća razloga zašto im se nije prikazivalo*/}
      {/* {props.isSubject ? null : <Menu.Item key="7" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/strucna-usavrsavanja">
          <ReadOutlined />
          <span>{" STRUČNA USAVRŠAVANJA"}</span>
        </Link>
      </Menu.Item>} */}
      <Menu.Item key="7" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/strucna-usavrsavanja">
          <ReadOutlined />
          <span>{" STRUČNA USAVRŠAVANJA"}</span>
        </Link>
      </Menu.Item>



      <Menu.Item key="9" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/evidencije">
          <ExceptionOutlined />
          <span> {" POSEBNE EVIDENCIJE"}</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="10" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} to="/kontakt">
          <PhoneOutlined />
          <span> {" KONTAKT"}</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="11" className="sidebar-focusable">
        <Link style={{ textDecoration: "none" }} onClick={props.downloadUputa} to="#">
          <DownloadOutlined />
          <span> {" KORISNIČKA UPUTA"}</span>
        </Link>
      </Menu.Item>
    </Menu>
  );
};

export default KorisnikView;
